import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "lat-lon" }
const _hoisted_3 = { class: "coords" }
const _hoisted_4 = { class: "action" }
const _hoisted_5 = {
  key: 0,
  class: "osm-attribution"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["disabled", "onClick", "onKeypress"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UndoIcon = _resolveComponent("UndoIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_MagnifyIcon = _resolveComponent("MagnifyIcon")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.loc), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.dirty ? '*' : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NcActions, { inline: 2 }, {
          default: _withCtx(() => [
            (_ctx.dirty)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: 0,
                  "aria-label": _ctx.t('memories', 'Reset'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reset())),
                  disabled: _ctx.disabled
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_UndoIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Reset')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.lat && _ctx.lon)
              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: 1,
                  "aria-label": _ctx.t('memories', 'Remove location'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clear())),
                  disabled: _ctx.disabled
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_CloseIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Remove location')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_NcTextField, {
      modelValue: _ctx.searchBar,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchBar) = $event)),
      label: _ctx.t('memories', 'Search'),
      placeholder: _ctx.t('memories', 'Search location / landmark'),
      disabled: _ctx.disabled,
      "trailing-button-icon": "arrowEnd",
      "show-trailing-button": _ctx.searchBar.length > 0 && !_ctx.loading,
      onTrailingButtonClick: _ctx.search,
      onKeypress: _withKeys(_ctx.search, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MagnifyIcon, { size: 16 })
      ]),
      _: 1
    }, 8, ["modelValue", "label", "placeholder", "disabled", "show-trailing-button", "onTrailingButtonClick", "onKeypress"]),
    (_ctx.isNominatim)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createTextVNode(" Powered by ", -1)),
          _createElementVNode("a", {
            href: _ctx.searchBase,
            target: "_blank"
          }, "Nominatim", 8, _hoisted_6),
          _cache[4] || (_cache[4] = _createTextVNode(" © ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("a", {
            href: "https://www.openstreetmap.org/copyright",
            target: "_blank"
          }, "OpenStreetMap", -1)),
          _cache[6] || (_cache[6] = _createTextVNode(" contributors ", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
          key: 1,
          class: "loading-spinner"
        }))
      : _createCommentVNode("", true),
    (_ctx.options.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.osm_id,
              disabled: _ctx.disabled,
              onClick: ($event: any) => (_ctx.select(option)),
              onKeypress: _withKeys(($event: any) => (_ctx.select(option)), ["enter"]),
              tabindex: "0"
            }, _toDisplayString(option.display_name), 41, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}